// DashboardServices.js
import React, { useEffect, useState } from "react";
import axios from "axios";

const DashboardServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    title: "",
    category: "registration",
    time: "",
    description: "",
  });
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // Fetch services
  const fetchServices = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_SERVICES_API}`);
      setServices(res.data.services || []); // fallback empty array
      setLoading(false);
    } catch (err) {
      console.error(err);
      setServices([]); // fallback
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await axios.put(`${process.env.REACT_APP_SERVICES_API}/${editId}`, formData);
        setEditId(null);
      } else {
        await axios.post(`${process.env.REACT_APP_SERVICES_API}`, formData);
      }
      setFormData({ title: "", category: "registration", time: "", description: "" });
      setShowForm(false);
      fetchServices();
    } catch (err) {
      console.error(err);
      alert("Failed to save service");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this service?")) {
      try {
        await axios.delete(`${process.env.REACT_APP_SERVICES_API}/${id}`);
        fetchServices();
      } catch (err) {
        console.error(err);
        alert("Failed to delete service");
      }
    }
  };

  const handleEdit = (service) => {
    setFormData({
      title: service.title,
      category: service.category,
      time: service.time_required,
      description: service.description,
    });
    setEditId(service.id);
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Styling
  const containerStyle = { padding: "20px", maxWidth: "1000px", margin: "50px auto", fontFamily: "Arial, sans-serif" };
  const buttonStyle = {
    padding: "10px 20px",
    backgroundColor: "#4CAF50",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    marginBottom: "20px",
  };
  const formStyle = { marginBottom: "30px", padding: "15px", border: "1px solid #ddd", borderRadius: "8px", backgroundColor: "#f9f9f9" };
  const inputStyle = { width: "100%", padding: "8px", marginBottom: "10px", borderRadius: "4px", border: "1px solid #ccc" };
  const cardStyle = { border: "1px solid #ddd", borderRadius: "10px", padding: "15px", width: "300px", backgroundColor: "#fff", boxShadow: "0 2px 6px rgba(0,0,0,0.1)" };
  const cardContainerStyle = { display: "flex", flexWrap: "wrap", gap: "15px", justifyContent: "flex-start" };
  const cardButtonStyle = { flex: 1, padding: "5px 10px", border: "none", borderRadius: "5px", cursor: "pointer" };
  const editBtnStyle = { ...cardButtonStyle, backgroundColor: "#2196F3", color: "#fff" };
  const deleteBtnStyle = { ...cardButtonStyle, backgroundColor: "#f44336", color: "#fff" };

  return (
    <div style={containerStyle}>
      <button onClick={() => setShowForm(!showForm)} style={buttonStyle}>
        {showForm ? "Close Form" : "Add New Service"}
      </button>

      {showForm && (
        <div style={formStyle}>
          <h2>{editId ? "Edit Service" : "Add New Service"}</h2>
          <form onSubmit={handleSubmit}>
            <div>
              <label>Title:</label>
              <input name="title" value={formData.title} onChange={handleChange} required style={inputStyle} />
            </div>

            <div>
              <label>Category:</label>
              <select name="category" value={formData.category} onChange={handleChange} style={inputStyle}>
                <option value="registration">Registration/Licences</option>
                <option value="filings">Filings</option>
                <option value="auditing">Auditing</option>
                <option value="certification">Certification</option>
              </select>
            </div>

            <div>
              <label>Time:</label>
              <input name="time" value={formData.time} onChange={handleChange} required style={inputStyle} />
            </div>

            <div>
              <label>Description:</label>
              <textarea name="description" value={formData.description} onChange={handleChange} required style={{ ...inputStyle, height: "80px" }} />
            </div>

            <button type="submit" style={buttonStyle}>{editId ? "Update Service" : "Add Service"}</button>
          </form>
        </div>
      )}

      <h2>Existing Services</h2>
      {loading ? (
        <p>Loading services...</p>
      ) : services.length === 0 ? (
        <p>No services found</p>
      ) : (
        <div style={cardContainerStyle}>
          {services.map((service) => (
            <div key={service.id} style={cardStyle}>
              <h3>{service.title}</h3>
              <p style={{color:"black"}}><strong>Category:</strong> {service.category}</p>
              <p style={{color:"black"}}><strong>Time:</strong> {service.time_required}</p>
              <p style={{color:"black"}}>{service.description}</p>
              <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                <button onClick={() => handleEdit(service)} style={editBtnStyle}>Edit</button>
                <button onClick={() => handleDelete(service.id)} style={deleteBtnStyle}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DashboardServices;
